function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, InputNumber, Switch, Modal, Alert, Upload, List } from "antd";
import Common from '../includes/Common';
import Webcam from "react-webcam";
import { HandIndexFill, ArrowClockwise, BoxFill, PencilSquare } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddPurchaseOrderDeliveryReport = function AddPurchaseOrderDeliveryReport(_ref) {
  var handler = _ref.handler,
    order = _ref.order;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    deliveryImage = _useState8[0],
    setDeliveryImage = _useState8[1];
  var _useState9 = useState(0),
    _useState0 = _slicedToArray(_useState9, 2),
    orderDelivered = _useState0[0],
    setOrderDelivered = _useState0[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var saveDelivery = function saveDelivery(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    if (deliveryImage == null) {
      setFormError("Veuillez capturer une photo du bon");
      return;
    }
    var formData = new FormData();
    formData.append('items_received', orderDelivered);
    formData.append('proof', deliveryImage);
    formData.append('delivery_note', values.delivery_note);
    formData.append('provider_purchase_order_id', order.id);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addpurchaseorderdeliveryreport', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  var onFinish = function onFinish(values) {
    confirm({
      title: 'Confirmez-vous la livraison ?',
      content: /*#__PURE__*/_jsxs("div", {
        style: {
          marginTop: "8px",
          padding: "6px",
          border: "1px dashed #528F69",
          borderRadius: "8px"
        },
        children: [/*#__PURE__*/_jsx("h6", {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["Commande N\xBA - ", /*#__PURE__*/_jsx("b", {
              children: order.id
            }), " pour ", /*#__PURE__*/_jsx("b", {
              children: order.provider.label
            })]
          })
        }), /*#__PURE__*/_jsx(List, {
          dataSource: order.provider_purchase_order_items,
          itemLayout: "vertical",
          size: "small",
          renderItem: function renderItem(item, index) {
            return /*#__PURE__*/_jsx(List.Item, {
              actions: [],
              children: /*#__PURE__*/_jsx(List.Item.Meta, {
                avatar: /*#__PURE__*/_jsx(BoxFill, {
                  size: 15
                }),
                title: item.label,
                description: /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "Prix: "
                    }), item.price.toLocaleString("Fr")]
                  }), /*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: " Qte: "
                    }), item.quantity]
                  }), " "]
                })
              })
            });
          }
        })]
      }),
      onOk: function onOk() {
        saveDelivery(values);
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        marginBottom: "18px",
        marginTop: "8px",
        padding: "6px",
        border: "1px dashed #528F69",
        borderRadius: "8px"
      },
      children: [/*#__PURE__*/_jsx("h6", {
        children: /*#__PURE__*/_jsxs("b", {
          children: ["Commande N\xBA - ", /*#__PURE__*/_jsx("b", {
            children: order.id
          }), " pour ", /*#__PURE__*/_jsx("b", {
            children: order.provider.label
          })]
        })
      }), /*#__PURE__*/_jsx(List, {
        dataSource: order.provider_purchase_order_items,
        itemLayout: "vertical",
        size: "small",
        renderItem: function renderItem(item, index) {
          return /*#__PURE__*/_jsx(List.Item, {
            actions: [],
            children: /*#__PURE__*/_jsx(List.Item.Meta, {
              avatar: /*#__PURE__*/_jsx(BoxFill, {
                size: 15
              }),
              title: item.label,
              description: /*#__PURE__*/_jsxs("div", {
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: "Prix: "
                  }), item.price.toLocaleString("Fr")]
                }), /*#__PURE__*/_jsxs("span", {
                  children: [/*#__PURE__*/_jsx("b", {
                    children: " Qte: "
                  }), item.quantity]
                }), " "]
              })
            })
          });
        }
      })]
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          banner: true,
          message: formError
        })
      }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          banner: true,
          message: formSuccess
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "items_received",
        label: "Confirmer la r\xE9ception \xE9ffective",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Switch, {
          defaultChecked: false,
          onChange: function onChange(checked) {
            setOrderDelivered(checked);
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "delivery_note",
        label: "Note de r\xE9ception",
        children: /*#__PURE__*/_jsx(TextArea, {})
      }), deliveryImage == null ? /*#__PURE__*/_jsx(Webcam, {
        audio: false,
        height: 300,
        mirrored: true,
        screenshotFormat: "image/jpeg",
        width: 380,
        children: function children(_ref2) {
          var getScreenshot = _ref2.getScreenshot;
          return /*#__PURE__*/_jsx(Button, {
            type: "default",
            icon: /*#__PURE__*/_jsx(HandIndexFill, {
              size: 22
            }),
            onClick: function onClick() {
              var imageSrc = getScreenshot();
              setDeliveryImage(imageSrc);
            },
            children: "Capturer le bon"
          });
        }
      }) : /*#__PURE__*/_jsxs("div", {
        style: {
          width: '380px'
        },
        children: [/*#__PURE__*/_jsx("img", {
          src: deliveryImage
        }), /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setDeliveryImage(null);
          },
          icon: /*#__PURE__*/_jsx(ArrowClockwise, {
            size: 20
          }),
          children: /*#__PURE__*/_jsx("b", {
            children: "Reprendre"
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), ContextHolder, /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disable: deliveryImage,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER LA LIVRAISON"
          })
        })
      })]
    })]
  });
};
export default AddPurchaseOrderDeliveryReport;